import debug from 'utils/debug';

const D2 = debug('m:CommuteOffer:IsEmpty');

// eslint-disable-next-line import/prefer-default-export
export const commuteOffer$IsEmpty = (commuteOffer) => {
  D2.S.INFO('commuteOffer$IsEmpty', { commuteOffer });

  return (
    !commuteOffer.stateless_api_request_data.nodes.length &&
    !commuteOffer.stateless_api_request_data.vehicles.length
  );
};
